define 'controller/ToggleSearchController', ['jquery', 'custom/media-query'], ($, mq) ->
  class ToggleSearch

    SEARCH_ICON_VISIBLE_CLASS  = 'header-icon__search--visible'
    OPEN_SEARCH_CLASS          = 'header__search--open'
    HIDE_SEARCH_CLASS          = 'header__search--hidden'
    SMALL_HEADER_CLASS         = 'pageheader__small'
    SHADOW_VISIBLE_CLASS       = 'header-container__shadow--visible'

    constructor: (@$el) ->
      container = @$el
      self = this

      $(container).on 'click', '.icon__search', (e) ->
        e.preventDefault()
        if $('.header__search').hasClass(HIDE_SEARCH_CLASS)
          self._showSearch()
          $(window).trigger 'scroll.filter'
        else
          self._hideSearch()

      $(window).on 'scroll.search', ->
        self._updateHeader()

      $(window).on 'resize', ->
        self._updateHeader()

    _updateHeader: ->
      self = this
      mq.update()
      if mq.up_to_M && !$('.header__search').hasClass(OPEN_SEARCH_CLASS) && $('.header-container').hasClass('header-container--sticky')
        if $('.header-container').hasClass('header-container--sticky') && ($(window).scrollTop() < 200)
          self._showSearch()
        else
          self._hideSearch()

        if ($(window).scrollTop() > 60)  && $('.header-container').hasClass('header-container--sticky')
          $('.header-container').addClass(SHADOW_VISIBLE_CLASS)
        else
          $('.header-container').removeClass(SHADOW_VISIBLE_CLASS)

    _showSearch: ->
      $('.header__search').addClass(OPEN_SEARCH_CLASS)    # avoid toggle loop because of on("scroll")
      $('.header-icon__search').removeClass(SEARCH_ICON_VISIBLE_CLASS)
      $('.header__search').removeClass(HIDE_SEARCH_CLASS)
      $('.pageheader').removeClass(SMALL_HEADER_CLASS)

      # avoid toggle loop because of on("scroll")
      setTimeout ->
        $('.header__search').removeClass(OPEN_SEARCH_CLASS)
      , 500

    _hideSearch: ->
      $('.header-icon__search').addClass(SEARCH_ICON_VISIBLE_CLASS)
      $('.header__search').addClass(HIDE_SEARCH_CLASS)
      $('.pageheader').addClass(SMALL_HEADER_CLASS)

    destroy: ->
      @$el.off()
      $(window).off() 'scroll.search'